import type { TouristSpot } from "@/services/touristSpotService";

interface SpotInfoProps {
  spot: TouristSpot;
}

export default function SpotInfo({ spot }: SpotInfoProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
      <span className="text-xs font-semibold uppercase tracking-[0.18em] text-secondary-700">
        About the place
      </span>
      <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        Why visit {spot.name}?
      </h2>
      <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
        {spot.description}
      </p>

      <div className="mt-6 flex flex-wrap gap-2">
        {spot.highlights.map((highlight) => (
          <span
            key={highlight}
            className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900"
          >
            <span className="flex h-3.5 w-3.5 items-center justify-center text-secondary-600">
              <i className="ri-checkbox-circle-line text-[13px]" />
            </span>
            {highlight}
          </span>
        ))}
      </div>

      <div className="mt-6 flex items-start gap-3 rounded-md border border-background-200 bg-background-100 px-4 py-3">
        <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center text-primary-600">
          <i className="ri-map-pin-2-line text-lg" />
        </span>
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500">
            Location
          </p>
          <p className="mt-0.5 text-sm text-foreground-800">{spot.address}</p>
        </div>
      </div>
    </div>
  );
}